import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, categories } from '../data/blog';
import PageSEO from '../components/PageSEO';

export default function Blog() {
  const [filter, setFilter] = useState('Tous');
  const allCats = ['Tous', ...categories];
  const filtered = filter === 'Tous' ? blogPosts : blogPosts.filter((p) => p.category === filter);

  return (
    <>
      <PageSEO
        title="Conseils Rénovation — Blog Apex Rénovation Berry"
        path="/blog"
        description="Conseils, astuces et actus sur la rénovation maison et commerce dans le Berry et l'Indre. Isolation, MaPrimeRénov', tendances déco, budgets travaux — par les artisans d'Apex Rénovation."
      />
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link>
            <span>/</span>
            <span className="text-white">Blog</span>
          </div>
          <h1 className="text-4xl font-extrabold text-white mb-3">Blog & Conseils Rénovation</h1>
          <p className="text-slate-400 text-lg max-w-2xl">Guides pratiques, tendances, aides financières... Tout ce qu'il faut savoir pour bien rénover.</p>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-3 mb-10 flex-wrap">
            {allCats.map((c) => (
              <button key={c} onClick={() => setFilter(c)} className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors ${filter === c ? 'bg-orange-600 text-white' : 'bg-white text-slate-700 border border-slate-200 hover:border-orange-300'}`}>{c}</button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {filtered.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="bg-white rounded-xl overflow-hidden border border-slate-200 hover:shadow-lg transition-shadow group flex flex-col">
                <div className="h-52 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="bg-orange-100 text-orange-700 text-xs font-semibold px-2.5 py-1 rounded-full">{post.category}</span>
                    <span className="text-slate-400 text-xs">{post.readTime} de lecture</span>
                  </div>
                  <h2 className="font-bold text-slate-900 text-lg leading-snug mb-3 group-hover:text-orange-600 transition-colors flex-1">{post.title}</h2>
                  <p className="text-slate-500 text-sm line-clamp-3 mb-4">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-xs text-slate-400 border-t border-slate-100 pt-4">
                    <span>Par {post.author}</span>
                    <span>{post.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-orange-600">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-extrabold text-white mb-3">Restez informé</h2>
          <p className="text-orange-100 mb-6 text-sm">Recevez nos conseils rénovation, actualités aides de l'État et inspirations directement dans votre boîte mail.</p>
          <form className="flex gap-3 max-w-md mx-auto" onSubmit={(e) => e.preventDefault()}>
            <input type="email" placeholder="votre@email.fr" className="flex-1 border-0 rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-white" />
            <button type="submit" className="bg-slate-900 hover:bg-slate-800 text-white font-bold px-5 py-3 rounded-lg transition-colors text-sm whitespace-nowrap">S'inscrire</button>
          </form>
        </div>
      </section>
    </>
  );
}
